import React, {Component} from 'react';
import {Route, Routes} from 'react-router-dom';
import Menu from './Menu';
import ThemeSetting from './ThemeSetting';
// import Searchbar from './Searchbar';
import Rightbar from './Rightbar';
import RoutesJson from '../Route';
import Invest from "../../pages/Invest";
import {CssBaseline} from "@mui/material";
import Header from "../../layout/header/Header";
import Sidebar from "../../layout/sidebar/Sidebar";


export default class Layout extends Component {
    render() {
        return (
            <>
                <ThemeSetting/>
                <CssBaseline />
                <div className="overlay"/>
                <div id="wrapper">
                    {/*<Header/>*/}
                    {/*<Searchbar/>*/}
                    {/*<Megamenu/>*/}
                    <Rightbar/>
                    {/*<Sidebar fixed changeMode={'changeMode'} mode={'mode'} />*/}

                    <Header fixed changeMode={'changeMode'} mode={'mode'} />
                    <Menu {...this.props} />
                    <div id="main-content">
                        <Routes>
                            {RoutesJson.map((layout, i) => {
                                return <Route key={`r${i}`} exact={layout.exact} path={layout.path}
                                              element={layout.component}/>
                            })}

                            <Route path="invest" element={<Invest />}></Route>
                        </Routes>
                    </div>
                </div>
            </>
        );
    }
}
